var trans = {
    "general": {
        "nav_zip_codes": "C\u00f3digos Postais",
        "nav_zip_code": "C\u00f3digo Postal",
        "nav_cp4_verification": "Verificar cp4",
        "nav_div_admin": "Divis\u00f5es Administrativas",
        "nav_counties": "Concelhos",
        "nav_simulators": "Simuladores",
        "nav_districts": "Distritos",
        "nav_hypermarkets": "Hipermercados",
        "nav_fregs": "Freguesias",
        "nav_demo_data": "Dados Demogr\u00e1ficos",
        "nav_fire_departments": "Corpos de Bombeiros",
        "nav_police_stations": "Esquadras de Pol\u00edcia",
        "nav_services": "Servi\u00e7os",
        "home": "Home",
        "nav_net_salary": "Vencimento l\u00edquido",
        "nav_sources": "Fontes",
        'nav_env_expenses': 'Despesas em Ambiente por Habitante',
        'nav_birth_rate': 'Taxa de Natalidade',
        "general": "Geral",
        "informations": "Informa\u00e7\u00f5es",
        "page_not_found": "A página não foi encontrada.",
        "censuses": 'Censos',
        "administrator": "Administrador"
    },
    "Home": {
        "home": "Home"
    },
    "Admin_Counties": {
        "search_county": "Procurar concelho",
        "resident_population": "Popula\u00e7\u00e3o residente",
        "population_density": "Densidade Populacional",
        "iso_code": "C\u00f3digo ISO",
        "iso_code_3": "C\u00f3digo de 3 letras",
        "area": "\u00c1rea",
        "map_style": "Estilo do mapa",
        "county": "Concelho",
        "meteorology": "meteorologia",
        "know_more": "Saber Mais"
    },
    "Admin_Districts": {
        "resident_population": "Popula\u00e7\u00e3o residente",
        "population_density": "Densidade Populacional",
        "iso_code": "C\u00f3digo ISO",
        "area": "Area",
        "map_style": "Estilo do mapa",
        "district": "Distrito",
        "search_district": "Procurar distrito",
        "meteorology": "meteorologia",
        "know_more": "Saber Mais"
    },
    "Admin_Fregs": {
        "resident_population": "Popula\u00e7\u00e3o residente",
        "population_density": "Densidade Populacional",
        "iso_code": "C\u00f3digo ISO",
        "area": "Area",
        "county": "Concelho",
        "map_style": "Estilo do mapa",
        "meteorology": "meteorologia",
        "parish": "Freguesia",
    },
    "Demo_Counties": {
        "graphic": "Gr\u00e1fico",
        "search_county": "Procurar concelho",
        "map_style": "Estilo do mapa",
        "population_density": "Densidade Populacional",
        "resident_population": "Popula\u00e7\u00e3o residente",
        "inhabitants_per_year": "Habitantes por ano",
        "county": "Concelho",
        "table": "Tabela",
        "yearly_evolution": 'Evolução Anual'
    },
    "Demo_Districts": {
        "graphic": "Gr\u00e1fico",
        "district": "Distrito",
        "population_density": "Densidade Populacional",
        "map_style": "Estilo do mapa",
        "resident_population": "Popula\u00e7\u00e3o residente",
        "search_district": "Procurar distrito",
        "inhabitants_per_year": "Habitantes por ano",
        "table": "Tabela",
        "yearly_evolution": 'Evolução Anual'
    },
    "Demo_Fregs": {
        "graphic": "Gr\u00e1fico",
        "county": "Concelho",
        "resident_population": "Popula\u00e7\u00e3o residente",
        "disclaimer": 'Aquando a realização destes censos ainda não tinha sido implementada a <a href="{assets_url}docs/agragacao_fregs_2013.pdf" target="_blank">agregação das freguesias</a>, de modo que não é possível facultar outros dados mais completos acerca das freguesias atuais e sua demografia.'
    },
    "Zip_Codes": {
        "map": "mapa",
        "county": "County",
        "map_style": "Estilo do mapa",
        "zip_code": "C\u00f3digo postal",
        "select_result_box": "Clique em um dos items da caixa da esquerda",
        "address": "Morada",
        "street_avenue": "Rua\/Avenida",
        "local_county": "Localidade\/Concelho",
        "results": "resultados",
        "district": "Distrito",
        "cod_arteria": "C\u00f3digo da art\u00e9ria",
        "cod_localidade": "C\u00f3digo da localidade",
        "tipo_arteria": "Tipo da art\u00e9ria",
        "titulo_arteria": "Titulo da art\u00e9ria",
        "primeira_preposicao": "Primeira preposi\u00e7\u00e3o",
        "segunda_preposicao": "Segunda preposi\u00e7\u00e3o",
        "designacao_arteria": "Designa\u00e7\u00e3o da art\u00e9ria",
        "descricao_troco": "Descri\u00e7\u00e3o do tro\u00e7o",
        "info_art\u00e9ria": "Informa\u00e7\u00e3o da art\u00e9ria",
        "nome_cliente": "Nome do cliente",
        "designacao_postal": "Designa\u00e7\u00e3o postal",
        "nome_localidade": "Nome da localidade",
        "cp4_verification": "Verificação de CP4",
        "zip_code_404": 'Código postal não encontrado',
        "cp4_404": 'CP4 não encontrado',
    },
    "Fire_Departments": {
        "map": "mapa",
        "map_style": "Estilo do mapa",
        "no_results": "N\u00e3o foram encontrados resultados para este concelho",
        "select_result_box": "Clique em um dos items da caixa da esquerda",
        "all_counties": "Todos os concelhos",
        "search_county": "Procurar concelho",
        "county": "Concelho",
        "district": "Distrito",
        "address": "Morada",
        "phone": "Telefone",
        "details": "Detalhes"
    },
    "Police_Stations": {
        "map": "mapa",
        "map_style": "Estilo do mapa",
        "no_results": "N\u00e3o foram encontrados resultados para este concelho",
        "select_result_box": "Clique em um dos items da caixa da esquerda",
        "all_counties": "Todos os concelhos",
        "search_county": "Procurar concelho",
        "county": "Concelho",
        "district": "Distrito",
        "name": "Nome",
        "phone": "Telefone",
        "address": "Morada"
    },
    "Hypermarkets": {
        "map": "mapa",
        "map_style": "Estilo do mapa",
        "no_results": "N\u00e3o foram encontrados resultados para este concelho",
        "select_result_box": "Clique em um dos items da caixa da esquerda",
        "all_counties": "Todos os concelhos",
        "search_county": "Procurar concelho",
        "county": "Concelho",
        "phone": "Telefone",
        "name": "Nome",
        "manager": "Gerente",
        "district": "Distrito",
        "schedule": "Horário",
        "address": "Morada"
    },
    "Net_Salary": {
        "dependents": "Dependentes",
        "year": "Ano",
        "others_renu_suj": "Outras Renumera\u00e7\u00f5es sujeitas a impostos",
        "others_renu_not_suj": "Outras Renumera\u00e7\u00f5es n\u00e3o sujeitas a impostos",
        "sector": "Setor",
        "5_or_more": "5 ou mais",
        "invalid_val": "Valor inv\u00e1lido, deve ser num\u00e9rico",
        "choose_one": "Escolha uma das op\u00e7\u00f5es",
        "subsidies": "Subs\u00eddios",
        "sub_alimentation": "Subsidio de alimenta\u00e7\u00e3o",
        "val_sub_alimentation": "Valor Subsidio de alimenta\u00e7\u00e3o",
        "paid_days": "N\u00famero de dias recebidos",
        "seg_social": "Seguran\u00e7a Social",
        "situation": "Situa\u00e7\u00e3o",
        "region": "Regi\u00e3o",
        "continent": "Continent",
        "private": "Privado",
        "public": "P\u00fablico",
        "base_salary": "Sal\u00e1rio Base",
        "sub_ali_total": "Subs\u00eddio de Alimenta\u00e7\u00e3o Total",
        "val_suj_seg_irs": "Valor sujeito a IRS e Seg. Social",
        "sub_ali_suj_seg_irs": "Subs\u00eddio de Alimenta\u00e7\u00e3o sujeito a IRS e Seg. Social",
        "total_brute": "Salário Bruto Total",
        "tax_irs": "Taxa de IRS",
        "tax_social_seg": "Taxa de Seg. Social",
        "tax_adse": "Taxa de ADSE",
        "retencao_irs_total": "Reten\u00e7\u00e3o de IRS Total",
        "seg_social_total": "Seguran\u00e7a Social Total",
        "total_taxes": "Imposto Total",
        "net_salary": "Remunera\u00e7\u00e3o L\u00edquida",
        "total_net_salary": "Remunera\u00e7\u00e3o Total"
    },
    'Enviroment_Expenses': {
        'comp_title': 'Despesas em ambiente por habitante',
        "year": "Ano",
        'district': 'Distrito'
    },
    'Birth_Rate': {
        'comp_title': 'Taxa de Natalidade por Município',
        "year": "Ano",
        "table": "Tabela",
        "graphic": "Gr\u00e1fico",
        'district': 'Distrito'
    },
    "404_not_found": {
        "page_not_found": "A página não foi encontrada."
    }
}

export default trans;